import { Amplify } from 'aws-amplify'
import '@aws-amplify/ui-vue'
import awsconfig from '@/aws-exports'

Amplify.Logger.LOG_LEVEL = 'INFO'
// TODO find a better logging framework or find a way to configure centrally log levels per named loggers

Amplify.configure(awsconfig)
